<!-- navbar-light bg-light-->

<template>
    <user-management></user-management>
    <nav class="navbar navbar-expand-lg navbar-dark app-navbar">
    <div class="container-fluid">
      <span class="navbar-brand d-flex align-items-center">
        <a href="/" class="text-decoration-none">
          <img src="/hb-logo.png" style="height:40px; margin-right:12px;" class=""/>
        </a>
        <span class="fw-bold">Stimmung 🥳</span>
      </span>
      <button class="navbar-toggler border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div class="navbar-nav ms-auto">
          <a class="nav-link modern-nav-link" href="https://herthabase.de">Zu Hertha BASE</a>
          <a class="nav-link modern-nav-link" href="https://spenden.herthabase.de">Spenden</a>
        </div>
      </div>
    </div>
  </nav>

    <div class="container-fluid mt-4 content-max-width">
      <main>
        <div class="row">
          <div class="col-12 d-flex justify-content-end mb-2">
            <push-notification-button></push-notification-button>
          </div>

          <div class="col-xl-12 col-12">
            <welcome-header />
          </div>

          <!-- Teleport-Ziel für die Ergebnis-Details (Trend/MOTM, siehe BarometerV2.vue).
               Muss im DOM VOR dem Barometer stehen, damit Teleport beim ersten Rendern
               zuverlässig funktioniert - die visuelle Reihenfolge wird über "order" gesteuert. -->
          <!-- Bewusst ohne mt-4: leer traegt dieses Element sonst trotzdem seinen eigenen
               Abstand bei und stoert die Luecke zum naechsten Element. Der Abstand nach oben
               gehoert dem Inhalt, der hier hineinteleportiert wird (siehe BarometerV2.vue). -->
          <div class="col-xl-12 col-12" id="result-details-target" style="order: 3;"></div>

          <div class="col-12 mt-4" style="order: 1;">
            <voting-form></voting-form>
          </div>

          <div class="col-12 mt-4" style="order: 2;">
            <show-barometer></show-barometer>
          </div>


          <div class="col-xl-12 col-12 mt-4" style="order: 4;">
            <mood-history-card></mood-history-card>
          </div>

          <div class="col-12 text-center" style="margin-top:25px; margin-bottom:100px; order: 6;">
            <a href='https://herthabase.de'><img src="./assets/hb-logo.png" style="max-width: 150px;" /></a>
          </div>
        </div>
      </main>
    </div>
    <footer class="modern-footer">
      <div class="container-fluid text-center">
        <span class="text-secondary">Oh yeah, it's a <a href="https://lixius.de" class="text-white fw-bold text-decoration-none">Lixius</a> product 😎</span>
      </div>
    </footer>
  </template>
  
  <style scoped>
  /* Bootstraps Standard-Focus-Ring bleibt nach Maus-/Touch-Klick haengen und wirkt wie ein
     haesslicher Rahmen um den Burger-Button. Fuer Tastatur-Fokus (:focus-visible) bleibt er
     aus Gruenden der Barrierefreiheit erhalten. */
  .navbar-toggler:focus:not(:focus-visible) {
    box-shadow: none;
  }

  .app-navbar {
    background: var(--overlay-strong);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid var(--card-border);
  }

  /* Bewusst nur auf dem Content-Bereich, nicht auf Navbar/Footer - deren Hintergrundfarbe soll
     weiterhin bis zum Bildschirmrand laufen, nur der Inhalt selbst soll nicht unbegrenzt mit der
     Bildschirmbreite mitwachsen. */
  .content-max-width {
    max-width: var(--content-max-width);
    margin-left: auto;
    margin-right: auto;
  }
  </style>

  <script>
  import WelcomeHeader from './components/WelcomeHeader';
  import ShowBarometer from './components/ShowBarometer';
  import VotingForm from './components/VotingForm';
  import UserManagement from './components/UserManagement';
  import MoodHistoryCard from './components/moodhistory/MoodHistoryCard.vue';
  import PushNotificationButton from './components/PushNotificationButton.vue';

  export default {
    components: {
      WelcomeHeader,
      ShowBarometer,
      VotingForm,
      UserManagement,
      MoodHistoryCard,
      PushNotificationButton
    },
    setup(){},
    mounted(){}
  }
  </script>
